export default "__VITE_ASSET__COvZyEwU__"